import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MainLayoutComponent } from 'src/app/shared/components/main-layout/main-layout.component';
import { Observable, of } from 'rxjs';
import { INSTALLATION_STEPS } from './installation-process.const';

type InstallationStep = {
  title: string;
  subtitle: string;
  text: string;
  active?: boolean;
}
@Component({
  selector: "app-installation-process",
  standalone: true,
  imports: [
    CommonModule,
    MainLayoutComponent
  ],
  templateUrl: "./installation-process.component.html",
  styleUrl: "./installation-process.component.scss",
})
export class InstallationProcessComponent {
  installationProcess: InstallationStep[] = INSTALLATION_STEPS;

  constructor() {}

  toggleItem(item: InstallationStep) {
    this.installationProcess.map(listItem => listItem.title === item.title ? listItem.active = !listItem.active : listItem.active = false)
  }

  onClickBack = (): Observable<any> => {
    return of(true);
  };

}
